import React, { useEffect, useState, useContext, useRef, useMemo } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";

import api from "services/api";

import { Card } from "@mui/material";
import Grid from "@mui/material/Grid";

import Tooltip from "@mui/material/Tooltip";
import Pagination from "@mui/material/Pagination";
import CardMedia from "@mui/material/CardMedia";

import DataTable from "examples/Tables/DataTable";
import Actionables from "components/UpStyled/Actionables";

import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import TableRowsIcon from "@mui/icons-material/TableRows";
import GridViewIcon from "@mui/icons-material/GridView";
import DeleteForeverRoundedIcon from "@mui/icons-material/DeleteForeverRounded";
import PageviewIcon from "@mui/icons-material/Pageview";
import EditIcon from "@mui/icons-material/Edit";
import ManageSearchIcon from "@mui/icons-material/ManageSearch";
import NoteAddIcon from "@mui/icons-material/NoteAdd";

import SuiBox from "components/SuiBox";
import SuiAvatar from "components/SuiAvatar";
import SuiSelect from "components/SuiSelect";
import SuiInput from "components/SuiInput";
import SuiButton from "components/SuiButton";
import Switch from "@mui/material/Switch";

import { capitalCase } from "capital-case";
import { AccountContext } from "context/account";
import CategoryContext from "context/category-context";

import Prompt from "components/UpStyled/Prompt";
import toast from "react-hot-toast";
import moment from "moment";
import qs from "query-string";
import { useForm, Controller } from "react-hook-form";

import { materialCategoryOptions } from "utils/data";

import CreateUWMaterialModal from "pages/unionwear/components/CreateUWMaterialModal";
import ImageCardWrapper from "components/UpStyled/ImageCardWrapper";
import ImportExcelModal from "pages/unionwear/components//ImportExcelModal";
import * as XLSX from "xlsx";

const MaterialLibrary = ({ sharedView = false }) => {
  const [data, setData] = useState([]);

  const [createMaterialVisible, setCreateMaterialVisible] = useState(false);
  const [editMaterialVisible, setEditMaterialVisible] = useState(false);
  const [selectedMaterial, setSelectedMaterial] = useState({});

  const [deleteVisible, setDeleteVisible] = useState(false);
  const [detailVisible, setDetailVisible] = useState(false);

  const [loading, setLoading] = useState(false);

  const [excelData, setExcelData] = useState([]);
  const [importExcelVisible, setImportExcelVisible] = useState(false);

  let location = useLocation();
  const navigate = useNavigate();

  const user = useContext(AccountContext);

  const {
    tree,
    actions: { findNodeByID, findParents },
  } = useContext(CategoryContext);

  const uploadExcelRef = useRef(null);

  useEffect(() => {
    retrieveMaterial();
  }, []);

  const retrieveMaterial = async () => {
    try {
      const { data } = await api.materialLibrary.list({
        order: "-updated_at",
      });
      setData(data?.materials || []);
    } catch (err) {
      toast.error(`Retrieve material list failed!`);
      console.log(err);
    }
  };

  const handleDeleteMaterial = async (material) => {
    try {
      await api.materialLibrary.delete(material.id);
      setDeleteVisible(false);
      retrieveMaterial();

      toast.success(`${material.name} has been removed successfully!`);
    } catch (err) {
      toast.error(`${material.name} could not be removed!`);
      console.log(err);
    }
  };

  const getMaterialTableRow = (item) => {
    const cate = materialCategoryOptions.find((x) => x.value == item?.category);
    const images = item?.metadata?.images || [];

    return {
      key: item.id,
      name: item?.name,
      category: cate ? cate.label : item?.category,
      code: item?.code,
      images: images,
      description: item?.metadata?.description,
      created_at: item.created_at,
      updated_at: item.updated_at,
      fabrication: item?.metadata?.fabrication,
      vendor: item?.metadata?.vendor,
      made_in_usa: item?.metadata?.made_in_usa,
      availability: item?.metadata?.availability,
      action: item,
    };
  };

  const columns = [
    {
      Header: "Image",
      accessor: "images",
      align: "center",
      Cell: ({ row, value }) => {
        return value && value.length > 0 ? (
          <ImageCardWrapper data={value[0]} width={50} height={50} />
        ) : null;
      },
    },
    {
      Header: "Name",
      accessor: "name",
      align: "center",
    },
    {
      Header: "Category",
      accessor: "category",
    },
    {
      Header: "Code",
      accessor: "code",
    },
    {
      Header: "Vendor",
      accessor: "vendor",
    },
    {
      Header: "Description",
      accessor: "description",
      Cell: ({ row, value }) => {
        return (
          <Tooltip title={value}>
            <div
              style={{
                wordBreak: "break-word",
                maxWidth: 200,
                overflow: "hidden",
                textOverflow: "ellipsis",
                display: "-webkit-box",
                WebkitLineClamp: "1",
                WebkitBoxOrient: "vertical",
              }}
            >
              {value}
            </div>
          </Tooltip>
        );
      },
    },
    {
      Header: "Last Edit",
      accessor: "updated_at",
      Cell: ({ row, value }) => {
        return value ? moment(value).format("MM/DD/YY") : "";
      },
    },
    {
      Header: "More",
      accessor: "action",
      isSorted: false,
      canSort: false,
      Cell: ({ row, value }) => (
        <SuiBox display="flex" alignItems="center" justifyContent="center" gap={0.5}>
          <Tooltip title="View Details">
            <SuiBox>
              <ManageSearchIcon
                fontSize={"small"}
                color="dark"
                sx={{ cursor: "pointer" }}
                onClick={(e) => {
                  e.stopPropagation();
                  setSelectedMaterial(value);
                  setDetailVisible(true);
                }}
              />
            </SuiBox>
          </Tooltip>
          |
          <Tooltip title="Edit">
            <SuiBox>
              <EditIcon
                fontSize={"small"}
                color="dark"
                sx={{ cursor: "pointer" }}
                onClick={(e) => {
                  e.stopPropagation();
                  setSelectedMaterial(value);
                  setEditMaterialVisible(true);
                }}
              />{" "}
            </SuiBox>
          </Tooltip>
          |{" "}
          <Tooltip title="Delete">
            <SuiBox>
              <DeleteForeverRoundedIcon
                fontSize={"small"}
                color="error"
                sx={{ cursor: "pointer" }}
                onClick={(e) => {
                  e.stopPropagation();
                  setSelectedMaterial(value);
                  setDeleteVisible(true);
                }}
              />{" "}
            </SuiBox>
          </Tooltip>
        </SuiBox>
      ),
    },
  ];

  const refresh = () => {
    retrieveMaterial();
  };

  const rows = data.map((item) => getMaterialTableRow(item));

  const handleRowClick = (row) => {
    setDetailVisible(true);
    setSelectedMaterial(row?.original.action);
  };

  const handleImportExcelMaterial = async (data) => {
    if (!data || data.length < 0) {
      handleClose();
      return;
    }

    let headerMap = {};
    for (let i = 0; i < data[0].length; i++) {
      let key = data[0][i].trim().toLowerCase().replaceAll(" ", "_");
      if (key == "material_name" || key == "name") {
        headerMap["name"] = i;
      } else if (key == "color_code" || key == "hex_code") {
        headerMap["color_code"] = i;
      } else if (key == "item_code") {
        headerMap["code"] = i;
      } else {
        headerMap[key] = i;
      }
    }

    let rows = [];
    console.log(headerMap);
    console.log(data);

    for (let i = 1; i < data.length; i++) {
      let name = headerMap["name"] != undefined ? data[i][headerMap["name"]] : undefined;
      let category = headerMap["category"] != undefined ? data[i][headerMap["category"]] : "fabric";
      if (!name) {
        continue;
      }

      let payload = {
        name: name,
        category: category,
        code: headerMap["code"] != undefined ? data[i][headerMap["code"]] : undefined,
        metadata: {
          description:
            headerMap["description"] != undefined ? data[i][headerMap["description"]] : undefined,
          fabrication:
            headerMap["fabrication"] != undefined ? data[i][headerMap["fabrication"]] : undefined,
          vendor: headerMap["vendor"] != undefined ? data[i][headerMap["vendor"]] : undefined,
          made_in_usa:
            headerMap["made_in_usa"] != undefined ? data[i][headerMap["made_in_usa"]] : undefined,
          availability:
            headerMap["availability"] != undefined ? data[i][headerMap["availability"]] : undefined,
          standard_cost:
            headerMap["standard_cost"] != undefined
              ? data[i][headerMap["standard_cost"]]
              : undefined,
          uom: headerMap["uom"] != undefined ? data[i][headerMap["uom"]] : undefined,
          yield_factor:
            headerMap["yield_factor"] != undefined ? data[i][headerMap["yield_factor"]] : undefined,
          color_code: headerMap["color_code" != undefined]
            ? data[i][headerMap["color_code"]]
            : undefined,
          color_names:
            headerMap["color_names"] != undefined ? data[i][headerMap["color_names"]] : undefined,
        },
      };

      rows.push(payload);
    }

    try {
      const created = await api.materialLibrary.bulkCreate({ data: rows });
      refresh();
      toast.success("Data has been imported Successfully");
    } catch (err) {
      console.log(err);
      toast.error(err?.message ? err?.message : "Failed to import data!");
    }
  };

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    const reader = new FileReader();

    reader.onload = (event) => {
      const data = new Uint8Array(event.target.result);
      const workbook = XLSX.read(data, { type: "array" });
      setExcelData(workbook);
      setImportExcelVisible(true);
    };

    reader.readAsArrayBuffer(file);
  };

  return (
    <SuiBox>
      <Backdrop sx={{ color: "info", zIndex: (theme) => 99999 }} open={loading}>
        <CircularProgress color="info" sx={{ mr: 1 }} size={32} />
      </Backdrop>
      <SuiBox display="flex" justifyContent="space-between" pt={2} px={2}>
        <SuiButton
          variant="gradient"
          color={"dark"}
          onClick={() => {
            setCreateMaterialVisible(true);
          }}
        >
          New Material
        </SuiButton>
        <SuiButton
          variant="gradient"
          color={"info"}
          onClick={() => {
            if (uploadExcelRef?.current) {
              uploadExcelRef.current.click();
              uploadExcelRef.current.value = null;
            }
          }}
        >
          Upload
        </SuiButton>
      </SuiBox>

      <Card sx={{ p: 3 }}>
        <DataTable
          table={{ columns, rows: rows }}
          entriesPerPage={{ defaultValue: 20 }}
          noEndBorder
          handleRowClick={handleRowClick}
          canSearch
        />
      </Card>
      {createMaterialVisible ? (
        <CreateUWMaterialModal
          handleClose={() => setCreateMaterialVisible(false)}
          visible={createMaterialVisible}
          isEdit={false}
          handleRefresh={refresh}
        />
      ) : null}
      {editMaterialVisible && selectedMaterial ? (
        <CreateUWMaterialModal
          handleClose={() => setEditMaterialVisible(false)}
          visible={editMaterialVisible}
          isEdit={true}
          handleRefresh={refresh}
          material={selectedMaterial}
        />
      ) : null}

      {detailVisible && selectedMaterial ? (
        <CreateUWMaterialModal
          handleClose={() => setDetailVisible(false)}
          visible={detailVisible}
          isEdit={false}
          readOnly={true}
          handleRefresh={refresh}
          material={selectedMaterial}
        />
      ) : null}
      {deleteVisible && selectedMaterial ? (
        <Prompt
          heading="Delete Material"
          text={`Are you sure you want to delete: ${selectedMaterial.name}`}
          visible={deleteVisible}
          okText="Delete"
          okColor="error"
          handleOk={() => handleDeleteMaterial(selectedMaterial)}
          handleClose={() => setDeleteVisible(false)}
        />
      ) : null}
      {importExcelVisible && excelData ? (
        <ImportExcelModal
          handleClose={() => setImportExcelVisible(false)}
          visible={importExcelVisible}
          handleOk={handleImportExcelMaterial}
          excelData={excelData}
          handleRefresh={refresh}
        />
      ) : null}
      <input
        type="file"
        accept=".xlsx, .xls"
        onChange={handleFileUpload}
        ref={uploadExcelRef}
        style={{ display: "none" }}
      />
    </SuiBox>
  );
};

export default MaterialLibrary;
